import { render, staticRenderFns } from "./Wordquestion.vue?vue&type=template&id=6e5f3538&scoped=true"
import script from "./Wordquestion.vue?vue&type=script&lang=js"
export * from "./Wordquestion.vue?vue&type=script&lang=js"
import style0 from "./Wordquestion.vue?vue&type=style&index=0&id=6e5f3538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f3538",
  null
  
)

export default component.exports